export const Courses_Form_Model = {
  Course_Name: "", // string 5
  Campus_Id: "", // dropdown - have to pass only id 4
  University_Id: "", // dropdown - have to pass only id
  Course_Url: "", // string 7
  Intakes: "", // dropdown - have to pass only id 16
  Duration: "", // int 10
  Yearly_Tuition_Fees: "", // dropdown - have to pass only int *
  IELTS_Required: "", // string
  PTE_Required: "", // string 14
  TOEFL_Required: "", // string
  GRE_Required: "", // string 12
  GMAT_Required: "", //string 13
  Duolingo_Required: "", //string 9
  // Entry_Requirement: "", // string - classic editor 11
  Application_Fees: "", // int 3
  Application_Deadline: "", // string 2
  Created_By: "0", // int 8
  Modified_By: "0", // int 17
  IELTS_Score: "", // dropdown - from 4.0 to 9.0 difference of 0.5 15
  Course_Type: "", // dropdown - have to pass only id 6
  duration_int: "0",
   Meta_Title :"",
    Meta_Description :"",
    OG_Image :"",
    Canonical_Url :""

};

export const Campus_Add_By_University_Model = {
  University_Id: "",
  Campus_Id: "",
  Course_Id: "",
};

export const IELTS_SCORE_SELECT_MODEL = [
  4.0, 4.5, 5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 8.0, 8.5, 9.0,
];

export const Course_Table_Model = [
  "Edit/Delete",
  "Course Name",
  "Campus Name",
  "University Name",
  "Country",
  "Course Link",
  "Duration",
  "Yearly Fees",
  "Application Fee",
  "Application Deadline",
  "IELTS Required",
  "PTE Required",
  "TOEFL Required",
  "GRE Required",
  "GMAT Required",
  "Duolingo Required",
  "IELTS Score",
  "Course Type",
];

export const Find_Courses_Model = {
  Country: "",
  University: "",
  StudyLevel: "",
  Intake: "",
  Duration: "",
  FeesFrom: "",
  FeesTill: "",
  IELTSScore: "",
  PageSize: 10,
  PageNo: 1,
  searchtxt: "",
  Popular_Courses: "",
  Global_Courses: "",
  Au_NZ_Popular_Courses: "",
  UK_IR_Popular_Courses: "",
};

export const Courses_Form_Model_Checker = (data) => {
  if (data.Course_Name === "" || data.Course_Name === null) {
    return ["Course Name is mandatory !"];
  } else if (data.University_Id === "" || data.University_Id === null) {
    return ["University name is mandatory!"];
  } else if (data.Course_Url === "" || data.Course_Url === null) {
    return ["Course Url is Mandatory !"];
  } else if (data.Intakes === "" || data.Intakes === null) {
    return ["Intake field is mandatory !"];
  } else if (data.duration_int === "" || data.duration_int === null) {
    return ["Duration Filter is mandatory !"];
  } else if (data.Duration === "" || data.Duration === null) {
    return ["Duration is mandatory !"];
  } else if (
    data.Yearly_Tuition_Fees === "" ||
    data.Yearly_Tuition_Fees === null
  ) {
    return ["Yearly tuition fees is mandatory !"];
  } else if (data.IELTS_Required === "" || data.IELTS_Required === null) {
    return ["IELTS Required is mandatory !"];
  } else if (data.PTE_Required === "" || data.PTE_Required === null) {
    return ["PTE Required is mandatory!"];
  } else if (data.TOEFL_Required === "" || data.TOEFL_Required === null) {
    return ["TOEFL Required is mandatory !"];
  } else if (data.GRE_Required === "" || data.GRE_Required === null) {
    return ["GRE Required is mandatory!"];
  } else if (data.GMAT_Required === "" || data.GMAT_Required === null) {
    return ["GMAT REQUIRED is mandatory!"];
  } else if (data.Duolingo_Required === "" || data.Duolingo_Required === null) {
    return ["Duolingo mandatory!"];
  } else if (data.Application_Fees === "" || data.Application_Fees === null) {
    return ["Application Fee is mandatory!"];
  } else if (
    data.Application_Deadline === "" ||
    data.Application_Deadline === null
  ) {
    return ["Application Deadline is mandatory!"];
  } else if (data.IELTS_Score === "" || data.IELTS_Score === null) {
    return ["IELTS Score is Mandatory!"];
  } else if (data.Course_Type === "" || data.Course_Type === null) {
    return ["Course Type mandatory!"];
  } else {
    return ["success"];
  }
};

const Duration = () => {
  let arr = [];
  for (let i = 1; i <= 5; i++) {
    arr.push(i);
  }

  return arr;
};
export const Duration_model = Duration();
